import { DynamoDBClient, GetItemCommand, PutItemCommand } from '@aws-sdk/client-dynamodb'
import { marshall, unmarshall } from '@aws-sdk/util-dynamodb'
import { type CreateLeadScoreRecord, type LeadScoreRecord, leadScoreRecordSchema } from './schema'

export class LeadScoreRecordRepository {
  private client: DynamoDBClient
  private tableName = 'lead_scores'

  constructor() {
    this.client = new DynamoDBClient({})
  }

  async create(record: CreateLeadScoreRecord): Promise<{ id: string }> {
    const id = crypto.randomUUID()
    const command = new PutItemCommand({
      TableName: this.tableName,
      Item: marshall({ ...record, id }, { removeUndefinedValues: true }),
    })
    await this.client.send(command)
    return { id }
  }

  async getById(id: string): Promise<LeadScoreRecord | null> {
    const command = new GetItemCommand({
      TableName: this.tableName,
      Key: marshall({ id }),
    })
    const result = await this.client.send(command)
    if (!result.Item) return null
    return leadScoreRecordSchema.parse(unmarshall(result.Item))
  }
}
